import React from 'react';
import { Link } from 'react-router-dom';
import { useCredits } from '../contexts/CreditsContext';
import '../styles/CreditBalance.css';

interface CreditBalanceProps {
  showBuyButton?: boolean;
  compact?: boolean;
}

export const CreditBalance: React.FC<CreditBalanceProps> = ({ 
  showBuyButton = true,
  compact = false 
}) => {
  const { credits, loading } = useCredits();

  if (loading) {
    return (
      <div className={`credit-balance ${compact ? 'credit-balance--compact' : ''}`}>
        <span className="credit-balance__loading">Loading...</span>
      </div>
    );
  }

  const balance = credits?.creditBalance ?? 0;
  const isLow = balance <= 1;
  const isEmpty = balance === 0;

  return (
    <div className={`credit-balance ${compact ? 'credit-balance--compact' : ''} ${isLow ? 'credit-balance--low' : ''}`}>
      <div className="credit-balance__info">
        <span className="credit-balance__icon">✏️</span>
        <span className="credit-balance__label">Credits:</span>
        <span className={`credit-balance__amount ${isEmpty ? 'empty' : ''}`}>
          {balance}
        </span>
      </div>
      
      {showBuyButton && (isLow || !compact) && (
        <Link to="/pricing" className="credit-balance__buy-btn">
          {isEmpty ? 'Buy Credits' : 'Get More'}
        </Link>
      )}
    </div>
  );
};

export default CreditBalance;
